import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, ChevronUp, FileText, CheckCircle } from 'lucide-react';
import './style/SelectExamFromPdf.css';

const pdfData = [
  {
    id: 1,
    title: "Section 1: Algebra",
    topics: [
      { id: 1, title: "Linear Equations" },
      { id: 2, title: "Quadratic Equations" },
      { id: 3, title: "Polynomials" },
      { id: 4, title: "Factorization" },
      { id: 5, title: "Algebraic Expressions" },
    ]
  },
  {
    id: 2,
    title: "Section 2: Geometry",
    topics: [
      { id: 6, title: "Triangles" },
      { id: 7, title: "Circles" },
      { id: 8, title: "Quadrilaterals" },
      { id: 9, title: "Coordinate Geometry" },
      { id: 10, title: "Trigonometry" },
    ]
  },
  {
    id: 3,
    title: "Section 3: Calculus",
    topics: [
      { id: 11, title: "Limits" },
      { id: 12, title: "Derivatives" },
      { id: 13, title: "Integrals" },
      { id: 14, title: "Applications of Derivatives" },
      { id: 15, title: "Applications of Integrals" },
    ]
  },
  {
    id: 4,
    title: "Section 4: Statistics",
    topics: [
      { id: 16, title: "Probability" },
      { id: 17, title: "Data Analysis" },
      { id: 18, title: "Regression" },
      { id: 19, title: "Hypothesis Testing" },
      { id: 20, title: "Confidence Intervals" },
    ]
  }
];

export default function SelectExamFromPdf() {
  const [expandedSections, setExpandedSections] = useState({});
  const [selectedTopics, setSelectedTopics] = useState({});
  const [animateIn, setAnimateIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setAnimateIn(true);
  }, []);

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const toggleTopic = (topicId) => {
    setSelectedTopics(prev => ({
      ...prev,
      [topicId]: !prev[topicId]
    }));
  };

  const handleCreateExam = () => {
    const selectedTopicIds = Object.keys(selectedTopics).filter(id => selectedTopics[id]);
    navigate(`/exams/exam-summary`, { state: { selectedTopicIds } });
  };

  const selectedTopicsCount = Object.values(selectedTopics).filter(Boolean).length;

  return (
    <div className='bg-gradient-to-br from-blue-100 to-purple-100 '>
    <div className={`unique16-select-exam-container  ${animateIn ? 'unique16-animate-in' : ''}`}>
      <div className="unique16-background-pattern"></div>
      <h1 className="unique16-title">
        <FileText className="unique16-title-icon" />
        Mathematics Syllabus
      </h1>
      <div className="unique16-pdf-content">
        {pdfData.map((section) => (
          <div key={section.id} className="unique16-section">
            <div 
              className="unique16-section-header" 
              onClick={() => toggleSection(section.id)}
            >
              <h2>{section.title}</h2>
              {expandedSections[section.id] ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
            </div>
            {expandedSections[section.id] && (
              <div className="unique16-topics">
                {section.topics.map((topic) => (
                  <div key={topic.id} className="unique16-topic">
                    <label className="unique16-topic-label">
                      <input
                        type="checkbox"
                        checked={selectedTopics[topic.id] || false}
                        onChange={() => toggleTopic(topic.id)}
                        className="unique16-topic-checkbox"
                      />
                      <span className="unique16-topic-title">{topic.title}</span>
                      {selectedTopics[topic.id] && (
                        <CheckCircle className="unique16-check-icon" size={20} />
                      )}
                    </label>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      <button 
        className="unique16-create-exam-btn"
        onClick={handleCreateExam}
        disabled={selectedTopicsCount === 0}
      >
        Create Exam ({selectedTopicsCount} topics selected)
      </button>
    </div>
    </div>
  );
}